import { useRestrictions } from "../hooks";
import Spinner from "../../../components/Spinners";
import { Restriction } from "../types";
import { BooleanBadge } from "./StatusBadge";

export function RestrictionsTable({ configId }: { configId: string }) {
  const { data, isLoading, isError } = useRestrictions(configId);
  const restrictions: Restriction[] = !isLoading && !isError && Array.isArray(data) ? data : [];

  function renderContent() {
    if (isLoading) {
      return (
        <div className="flex justify-center py-4">
          <Spinner className="text-black" />
        </div>
      );
    }
    if (isError) {
      return <p className="text-sm text-red-500">Failed to load restrictions.</p>;
    }
    if (restrictions.length === 0) {
      return <p className="text-sm text-gray-400">No restrictions configured.</p>;
    }
    return (
      <div className="overflow-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F4F4F6]">
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase rounded-tl-lg rounded-bl-lg">
                PMS Rate ID
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Type
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Days of Week
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Date Range
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Min LOS
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Max LOS
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Min Advance
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Max Advance
              </th>
              <th className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase rounded-tr-lg rounded-br-lg">
                Active
              </th>
            </tr>
          </thead>
          <tbody>
            {restrictions.map((r) => (
              <tr key={r.id} className="border-b border-b-[#E9E9EB]">
                <td className="px-3 py-2 font-mono text-xs">{r.pmsRateId}</td>
                <td className="px-3 py-2">{r.conditionType}</td>
                <td className="px-3 py-2">
                  {r.daysOfWeek?.join(", ") || "All"}
                </td>
                <td className="px-3 py-2">
                  {r.startDate || r.endDate
                    ? `${r.startDate || "..."} - ${r.endDate || "..."}`
                    : "Any"}
                </td>
                <td className="px-3 py-2">{r.minLengthOfStay ?? "-"}</td>
                <td className="px-3 py-2">{r.maxLengthOfStay ?? "-"}</td>
                <td className="px-3 py-2">{r.minAdvanceDays ?? "-"}</td>
                <td className="px-3 py-2">{r.maxAdvanceDays ?? "-"}</td>
                <td className="px-3 py-2 text-center">
                  <BooleanBadge value={r.isActive} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-4">
      <h3 className="text-base font-semibold text-gray-900 mb-4">Restrictions</h3>
      {renderContent()}
    </div>
  );
}
